import React from 'react';
import styled from 'styled-components';
import { XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const Container = styled.div`
  max-width: 600px;
  margin: 0 auto;
  padding: 3rem 1rem;
  text-align: center;
`;

const IconWrapper = styled.div`
  display: inline-flex;
  width: 72px;
  height: 72px;
  border-radius: 999px;
  align-items: center;
  justify-content: center;
  background: #fef2f2;
  color: #dc2626;
  margin-bottom: 1rem;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 800;
  color: #111827;
  margin-bottom: 0.5rem;
`;

const Text = styled.p`
  font-size: 0.95rem;
  color: #4b5563;
  margin-bottom: 1.5rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 0.75rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Button = styled(Link)`
  padding: 0.7rem 1.3rem;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  text-decoration: none;
  border: 1px solid #e5e7eb;
  color: #111827;
  background: white;
`;

const PrimaryButton = styled(Button)`
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  border-color: transparent;
`;

const PaymentFail = () => {
  return (
    <Container>
      <IconWrapper>
        <XCircle size={32} />
      </IconWrapper>
      <Title>Ödeme Başarısız</Title>
      <Text>
        Ödeme işleminiz tamamlanamadı. Kart bilgileriniz veya banka onayıyla ilgili bir sorun olabilir.
      </Text>
      <ButtonRow>
        <PrimaryButton to="/pricing">Tekrar dene</PrimaryButton>
        <Button to="/">Ana sayfaya dön</Button>
      </ButtonRow>
    </Container>
  );
};

export default PaymentFail;

